import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { WeekDay } from "../UserMasterWorkSchedule";

type Props = {
  value: WeekDay;
  size?: number | string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WeekdayContent',
  props: {
    value: null,
    size: { default: 32 }
  },
  setup(__props: any) {

const props = __props as { value: WeekDay, size: number | string };



const items = [
  { value: WeekDay.Monday, text: "月", color: "yellow darken-2" },
  { value: WeekDay.Tuesday, text: "火", color: "pink darken-1" },
  { value: WeekDay.Wednesday, text: "水", color: "green darken-2" },
  { value: WeekDay.Thursday, text: "木", color: "deep-orange" },
  { value: WeekDay.Friday, text: "金", color: "blue" },
  { value: WeekDay.Saturday, text: "土", color: "deep-purple" },
  { value: WeekDay.Sunday, text: "日", color: "red" }
] as const;

const index = computed(() => items.findIndex(e => e.value === props.value));

return { __sfc: true,props, items, index }
}

})